//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseString } from '~/components/emoji/emoji-parse'

export default {
    name: 'CourierMessage',
    props: {
        id: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        from: {
            type: String,
            required: true
        },
        to: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        },
        fileName: {
            type: String,
            defaultValue: ''
        },
        headUrl: {
            type: String
        },
        name: {
            type: String,
            required: true
        },
        sendTime: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            required: true
        }
    },
    data() {
        return {}
    },
    computed: {
        contents() {
            if (this.type === '1') {
                return parseString(this.content)
            } else {
                return content
            }
        }
    },
    methods: {
        handleFileClick() {
            window.open(this.$absUrl(this.content))
        }
    }
}
